// document.addEventListener('DOMContentLoaded', () => {
//   // Mobile Drawer Toggle (Opens drawer)
//   const mobileToggles = document.querySelectorAll('.mobile-toggle');
//   const mobileDrawer = document.querySelector('.mobile-drawer');
//   const closeBtn = document.querySelector('.md-close-btn');

//   if (mobileDrawer && mobileToggles.length > 0) {
//     mobileToggles.forEach(toggle => {
//       toggle.addEventListener('click', (e) => {
//         e.preventDefault();
//         mobileDrawer.classList.toggle('is-open');
//         document.body.classList.toggle('drawer-open');
//       });
//     });
//   }

//   // Close Drawer via the Close button inside the drawer
//   if (mobileDrawer && closeBtn) {
//     closeBtn.addEventListener('click', (e) => {
//       e.preventDefault();
//       mobileDrawer.classList.remove('is-open');
//       document.body.classList.remove('drawer-open');
//     });
//   }

//   // Accordion sub-menu toggles
//   const accordionHeads = document.querySelectorAll('.md-accordion-head');
//   accordionHeads.forEach(head => {
//     head.addEventListener('click', () => {
//       const parentItem = head.closest('.md-item');
//       parentItem.classList.toggle('is-active');
      
//       const body = parentItem.querySelector('.md-accordion-body');
//       const iconSpan = head.querySelector('.md-icon');
      
//       if (body) {
//         if (body.style.maxHeight) {
//           body.style.maxHeight = null;
//           if (iconSpan) iconSpan.textContent = '+';
//         } else {
//           body.style.maxHeight = body.scrollHeight + 'px';
//           if (iconSpan) iconSpan.textContent = '-';
//         }
//       }
//     });
//   });
// });




document.addEventListener('DOMContentLoaded', function() {
  const mobileToggleBtn = document.querySelector('.mobile-toggle');
  const mobileDrawer = document.querySelector('.mobile-drawer');
  const closeBtn = document.querySelector('.md-close-btn');

  // Open Drawer
  if (mobileToggleBtn && mobileDrawer) {
    mobileToggleBtn.addEventListener('click', function() {
      mobileDrawer.classList.add('is-open');
    });
  }

  // Close Drawer
  if (closeBtn && mobileDrawer) {
    closeBtn.addEventListener('click', function() {
      mobileDrawer.classList.remove('is-open');
    });
  }

  // Accordion Expand/Collapse Logic
  const accordionHeads = document.querySelectorAll('.md-accordion-head');
  
  accordionHeads.forEach(function(head) {
    head.addEventListener('click', function() {
      const parentItem = this.parentElement;
      const icon = this.querySelector('.md-icon');
      const isOpen = parentItem.classList.contains('is-active');
      
      // Close all other active items
      document.querySelectorAll('.md-item').forEach(function(item) {
        item.classList.remove('is-active');
        const itemIcon = item.querySelector('.md-icon');
        if (itemIcon) itemIcon.textContent = '+';
      });

      // Toggle current item
      if (!isOpen) {
        parentItem.classList.add('is-active');
        if (icon) icon.textContent = '×';
      }
    });
  });
});
